import React from 'react';
import { Modal } from 'antd';
import Ficon from '../Ficon';
import style from './index.less';

class BaseModal {
    defaultOptions = {
        centered: true,
        width: 300,
    };

    renderContent = (icon, title, content)=> {
        const color = icon === 'warn' ? '#E33100' : icon === 'success' ? '#4FCB5A' : '';
        const ficonStyle = {fontSize: 80, color: `${color}`};
        return (
            <div>
                <div className={style.header}><Ficon type={icon} style={ficonStyle}/></div>
                <div className={style.title}>{title}</div>
                <div className={style.content}>{content}</div>
            </div>
        );
    }
    _showModal = (params)=> {
        const modalClass = params && params.onCancel ? 'my-modal' : 'my-modal-single';
        const options = Object.assign(this.defaultOptions, params, {
            title: '',
            className: style[modalClass]
        });
        Modal.confirm(options);
    }
    success = (params)=>{
        const _content = this.renderContent('success', params.title, params.content);
        params['content'] = _content;
        this._showModal(params);
    }
    warning = (params)=> {
        const _content = this.renderContent('warn', params.title, params.content);
        params['content'] = _content;
        this._showModal(params);
    }
    error = (params)=> {
        const _content = this.renderContent('warn', params.title, params.content);
        params['content'] = _content;
        this._showModal(params);
    }
}

export default new BaseModal();



// WEBPACK FOOTER //
// ./src/components/BaseModal/index.js